const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_authenticated-user/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_authenticated-user/superuser/afpant/$orgNumber/pantedokument/$pantedokumentId/")({
  loader: async ({
    params
  }) => {
    const {
      orgNumber,
      pantedokumentId
    } = params;
    const res = await routeLoaderApiClient.superuser.afpant[":orgNumber"].pantedokument[":pantedokumentId"].$get({
      param: {
        orgNumber,
        pantedokumentId
      }
    });
    if (res.ok === false) {
      throw new Error("Failed to fetch pantedokument message");
    }
    return {
      pantedokument: await res.json()
    };
  },
  head: () => ({
    meta: [{
      title: "Pantedokument | Alice & Bob"
    }]
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});